const NUMERIC_REGEX = /[^0-9]/g;
const STRING_REGEX = /[^\D]/g;

function compareYearGroups(a: string, b: string) {
  // extract the numeric portions of the strings
  const numericA = a.replace(NUMERIC_REGEX, '');
  const numericB = b.replace(NUMERIC_REGEX, '');

  if (numericA === a && numericB === b) {
    // both year groups are strictly numbers, so sort numerically
    return parseInt(a) > parseInt(b) ? 1 : -1;
  } else if (numericA === a) {
    // a is strictly a number, so it should be first
    return -1;
  } else if (numericB === b) {
    // b is strictly a number, so it should be first
    return 1;
  }

  // otherwise both have letters in them
  const stringA = a.replace(STRING_REGEX, '');
  const stringB = b.replace(STRING_REGEX, '');

  if (stringA === a) {
    // a is strictly a string, so it should be last
    return 1;
  } else if (stringB === b) {
    // b is strictly a string, so it should be last
    return -1;
  }

  // prioritize letters sorting
  if (stringA > stringB) {
    return 1;
  } else if (stringA < stringB) {
    return -1;
  }

  // otherwise sort by numeric as last resort
  return parseInt(numericA) > parseInt(numericB) ? 1 : -1;
}

/**
 * Sorts an array of year groups by returning a copied array that is properly
 * sorted. Year groups prioritize ordering strictly numeric-only groups first,
 * and then year groups with letters and numbers, by the letter. Letter-only
 * groups are sorted last.
 * @param yearGroups A simple string array of year groups.
 * @returns A simple string array of sorted year groups.
 */
export default function sortYearGroups(yearGroups: string[] = []): string[] {
  return yearGroups.concat().sort(compareYearGroups);
}
